export default __webpack_public_path__ + "static/media/SecondPageLanding.d9b10400.jpeg";